import colors from '../../../../theme/foundations/colors'
import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'
import size from '../../../../utills/size'

export const styleArrowIcon = {
    height: [pxToRem(18), pxToRem(18), pxToRem(22), pxToRem(22)],
    aspectRatio: 'auto 13 / 24'
}

export const promoBannerStyle = {
    backgroundColor: colors.cav_red,
    paddingLeft: [pxToRem(11), pxToRem(11), pxToRem(45), pxToRem(45)],
    paddingRight: [pxToRem(11), pxToRem(11), pxToRem(45), pxToRem(45)],
    alignItems: 'center',
    color: 'white',
    '.slide-item + .slide-item': {
        visibility: 'hidden'
    },
    '.slider': {
        paddingTop: [pxToRem(7), pxToRem(7), pxToRem(7), pxToRem(7)],
        paddingBottom: [pxToRem(7), pxToRem(7), pxToRem(7), pxToRem(7)],
        maxWidth: size.xxl,
        margin: '0 auto'
    },
    '.slick-slider': {
        display: 'flex',
        alignItems: 'center',
        '.slide-item + .slide-item': {
            visibility: 'visible'
        }
    },
    '.slick-slide': {
        minHeight: pxToRem(30),
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'center',
        'div > div': {
            display: 'flex !important'
        }
    },
    '.slick-slider svg': {
        color: 'white'
    },
    '.arrow': {
        backgroundColor: 'transparent',
        display: 'inline-block',
        height: 'unset',
        width: 'unset',
        padding: '0',
        minWidth: [pxToRem(10), pxToRem(10), pxToRem(12), pxToRem(12)],
        _hover: {
            backgroundColor: 'transparent'
        },
        _disabled: {
            backgroundColor: 'transparent',
            cursor: 'not-allowed',
            opacity: '0.4',
            _hover: {
                backgroundColor: 'transparent'
            }
        }
    },
    '.slide-item': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        color: 'white',
        textAlign: 'center',
        fontFamily: fonts.primary,
        fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: pxToRem(0.8),
        paddingLeft: pxToRem(10),
        paddingRight: pxToRem(10)
    },
    '.slide-item a': {
        color: 'white',
        textAlign: 'center',
        fontFamily: fonts.primary,
        fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: pxToRem(0.8)
    }
}
